import { Component, Input, ViewChild, OnInit } from '@angular/core';

import { ApiError, ConfigService, MessageService, DateUtilsHttpService } from '../../../../core';
import { ClienteAnaliseMercadoFilter } from '../../adapters';

import { ClienteAnaliseMercadoPerspectivaProjetadaListComponent } from './list';
import { GrupoClassificacao, GrupoClassificacaoCrudHttpService } from '../../../grupo-classificacao';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sgt-cliente-analise-mercado-perspectiva-projetada',
    templateUrl: './cliente-analise-mercado-perspectiva-projetada.component.html',
    styleUrls: ['./cliente-analise-mercado-perspectiva-projetada.component.less']
})
export class ClienteAnaliseMercadoPerspectivaProjetadaComponent implements OnInit {
    /** Se já verificou se são o mês e ano atuais */
    isMesAtualInitChecked = false;
    /** Se são o mês e ano atuais */
    isMesAtual: boolean;

    /** Grupo de Classificação selecionado */
    grupoClassificacao: GrupoClassificacao;
    /** Se está carregando o grupo de classificação */
    isLoadingGrupoClassificacao: boolean;
    /** Se carregou o grupo de classificação */
    isLoadedGrupoClassificacao: boolean;

    @Input() isVisualizacaoModoList: boolean;
    @Input() filter: ClienteAnaliseMercadoFilter;

    @ViewChild('list') list: ClienteAnaliseMercadoPerspectivaProjetadaListComponent;

    constructor(private configService: ConfigService,
                private messageService: MessageService,
                private dateUtilsHttpService: DateUtilsHttpService,
                private grupoClassificacaoCrudHttpService: GrupoClassificacaoCrudHttpService) { }

    ngOnInit() {
        // Verificando se é o mês atual
        this.getIsMesAtual()
            .then(() => this.isMesAtualInitChecked = true)
            .catch(() => this.isMesAtualInitChecked = true);
    }

    /** Obtem se o mês do filtro é o mês atual */
    private getIsMesAtual(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dateUtilsHttpService.isMesAtual(this.filter?.mes, this.filter?.ano)
            .subscribe(
                response => {
                    this.isMesAtual = response;
                    resolve();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao verificar se o mês selecionado é o mês atual', error);
                    reject();
                }
            );
        });
    }

    private loadGrupoClassificacao(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Obtendo o ID do grupo selecionado
            const idGrupoClassificacao = this.filter?.getGrupoClassificacaoSelecionado() ?? null;

            // Grupo não selecionado
            if (!idGrupoClassificacao) {
                this.grupoClassificacao = null;
                resolve();
                return;
            }

            // Mesmo grupo atualmente selecionado
            if (this.grupoClassificacao?.id === idGrupoClassificacao) {
                resolve();
                return;
            }

            // Carregando o grupo de classificação
            this.grupoClassificacao = null;
            this.grupoClassificacaoCrudHttpService.load(idGrupoClassificacao)
                .pipe(
                    take(1)
                )
                .subscribe(
                    grupoClassificacao => {
                        this.grupoClassificacao = grupoClassificacao;
                        setTimeout(() => resolve(), 0);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar o grupo de segmentos selecionado', error);
                        reject();
                    }
                );
        });
    }

    private beforeSearch(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoadingGrupoClassificacao = true;
            this.isLoadedGrupoClassificacao = false;

            Promise.all([
                this.loadGrupoClassificacao(),
                this.getIsMesAtual()
            ]).then(() => {
                this.isLoadingGrupoClassificacao = false;
                this.isLoadedGrupoClassificacao = true;
                resolve();
            })
            .catch(() => {
                this.isLoadingGrupoClassificacao = false;
                this.isLoadedGrupoClassificacao = false;
                reject();
            });
        });
    }

    async search() {
        try {
            await this.beforeSearch();

            if (this.isVisualizacaoModoList) { // List
                this.list?.search();
            }
        } catch (error) {
            console.error(error);
        }
    }
}
